import React from "react";
import Header from "./components/Header";
import MemeGenerator from "./components/MemeComponent";

function App() {
  return (
    <>
    <Header />
    <MemeGenerator />
    </>
  );
}

export default App;
